import { useState, useEffect, useMemo } from "react";
import { Button } from "../ui/Button";
import { Input } from "../ui/Input";
import { Calendar, ChevronLeft, ChevronRight, Search, RefreshCw } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../ui/Table";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/Card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/Tabs";
import Badge from "../ui/Badge";
import { Separator } from "../ui/Separator";
import { PaginationExample } from "../ui/Pagination";



export default function Prolongation() {
  const [currentDateRange, setCurrentDateRange] = useState(
    "07/04/2025-13/04/2025",
  );
  const [searchQuery, setSearchQuery] = useState("");
  const [activeTab, setActiveTab] = useState("toutes");
  const [groupByClient, setGroupByClient] = useState(false);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20; 


  // Données simulées
  const contrats = [
    {
  id: "17",
  numero: "1618",
  client: "TECHNO BUILD",
  interim: "ALBERT THOMAS",
  dateDebut: "10/04",
  dateFin: "15/04",
  souplesse: "+2 jours",
  statut: "à traiter",
},
{
  id: "18",
  numero: "1617",
  client: "INNOV CONCEPT",
  interim: "MURPHY LISA",
  dateDebut: "11/04",
  dateFin: "14/04",
  souplesse: "+1 jour",
  statut: "à traiter",
},
{
  id: "19",
  numero: "1615",
  client: "NEXT ENGINEERING",
  interim: "LEE JASON",
  dateDebut: "09/04",
  dateFin: "13/04",
  souplesse: "Aucune",
  statut: "à traiter",
  decisionClient: "Prolongé jusqu'à fin avril",
},
{
  id: "20",
  numero: "1614",
  client: "GLOBAL SERVICES",
  interim: "GONZALEZ ANA",
  dateDebut: "10/04",
  dateFin: "11/04",
  souplesse: "Aucune",
  statut: "à traiter",
  decisionClient: "Fin de mission immédiate",
},
{
  id: "21",
  numero: "1613",
  client: "CITY BUILD",
  interim: "NGOMA PAUL",
  dateDebut: "08/04",
  dateFin: "10/04",
  souplesse: "+3 jours",
  statut: "à traiter",
},

    {
      id: "1",
      numero: "1673",
      client: "LES GÂTINES",
      interim: "SAM OMAR",
      dateDebut: "07/04",
      dateFin: "11/04",
      souplesse: "+2 jours",
      statut: "à traiter",
    },
    {
      id: "2",
      numero: "1672",
      client: "LES GÂTINES",
      interim: "N'GOYE ABDOULAYE",
      dateDebut: "07/04",
      dateFin: "11/04",
      souplesse: "+3 jours",
      statut: "à traiter",
    },
    {
      id: "3",
      numero: "1671",
      client: "LES GÂTINES",
      interim: "DIALLO MAMADOU LAMARANA",
      dateDebut: "08/04",
      dateFin: "11/04",
      souplesse: "+1 jour",
      statut: "à traiter",
    },
    {
      id: "4",
      numero: "1669",
      client: "SOLS DOUMER",
      interim: "DIABIRA ISSAH",
      dateDebut: "08/04",
      dateFin: "09/04",
      souplesse: "Aucune",
      statut: "à traiter",
    },
    {
      id: "5",
      numero: "1665",
      client: "ETUDES PLUS",
      interim: "HENRY DAVID",
      dateDebut: "05/04",
      dateFin: "10/04",
      souplesse: "+5 jours",
      statut: "à traiter",
      decisionClient: "Prolongé de 1 mois",
    },
    {
      id: "6",
      numero: "1660",
      client: "MEDIA PRIME",
      interim: "LEFEVRE SOPHIE",
      dateDebut: "01/04",
      dateFin: "08/04",
      souplesse: "Aucune",
      statut: "à traiter",
      decisionClient: "Fin de mission",
    },
    {
      id: "7",
      numero: "1655",
      client: "LES GÂTINES",
      interim: "PIERRE MARTIN",
      dateDebut: "09/04",
      dateFin: "12/04",
      statut: "à traiter",
    },
    {
      id: "8",
      numero: "1652",
      client: "SOLS DOUMER",
      interim: "DUPONT JEAN",
      dateDebut: "10/04",
      dateFin: "13/04",
      statut: "à traiter",
    },
    {
      id: "9",
      numero: "1645",
      client: "LES GÂTINES",
      interim: "RODRIGUEZ MARIA",
      dateDebut: "07/04",
      dateFin: "10/04",
      statut: "à traiter",
    },
    {
      id: "10",
      numero: "1644",
      client: "ETUDES PLUS",
      interim: "GARCIA MANUEL",
      dateDebut: "08/04",
      dateFin: "10/04",
      statut: "renouvelé",
    },
    {
      id: "11",
      numero: "1642",
      client: "MEDIA PRIME",
      interim: "ZHANG WEI",
      dateDebut: "12/04",
      dateFin: "13/04",
      statut: "à traiter",
    },
    {
      id: "12",
      numero: "1638",
      client: "SOLS DOUMER",
      interim: "NGUYEN LINH",
      dateDebut: "11/04",
      dateFin: "13/04",
      statut: "renouvelé",
    },
    {
      id: "13",
      numero: "1632",
      client: "LES GÂTINES",
      interim: "JOHNSON ROBERT",
      dateDebut: "09/04",
      dateFin: "12/04",
      statut: "à traiter",
    },
    {
      id: "14",
      numero: "1628",
      client: "ETUDES PLUS",
      interim: "MARTINEZ LUCIA",
      dateDebut: "07/04",
      dateFin: "09/04",
      statut: "arrêté",
    },
    {
      id: "15",
      numero: "1625",
      client: "MEDIA PRIME",
      interim: "BROWN SARAH",
      dateDebut: "10/04",
      dateFin: "12/04",
      statut: "à traiter",
    },
    {
      id: "16",
      numero: "1620",
      client: "SOLS DOUMER",
      interim: "KIM MIN-JI",
      dateDebut: "11/04",
      dateFin: "13/04",
      statut: "à traiter",
    },
  ];

  const normalize = (str) =>
  typeof str === "string"
    ? str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
    : "";

const filteredContrats = contrats.filter((contrat) => {
  // Filtrage par tab
  if (activeTab === "aTraiter" && contrat.statut !== "à traiter") return false;
  if (activeTab === "aRenouveler" && contrat.statut !== "renouvelé") return false;
  if (activeTab === "aArreter" && contrat.statut !== "arrêté") return false;

  // Si rien n'est tapé dans la recherche, on garde tout
  if (!searchQuery) return true;

  // Normalisation des champs à comparer
  const candidat = normalize(contrat.candidat);
  const numero = normalize(contrat.numero);
  const searchTerm = normalize(searchQuery);

  return candidat.includes(searchTerm) || numero.includes(searchTerm);
});


  const aTraiterContrats = filteredContrats.filter(c => c.statut === "à traiter");
  const aRenouvelerContrats = filteredContrats.filter(c => c.statut === "renouvelé");
  const aArreterContrats = filteredContrats.filter(c => c.statut === "arrêté");


  // Regrouper par client si l'option est activée
  const groupedByClient = groupByClient
    ? filteredContrats.reduce((acc, contrat) => {
        if (!acc[contrat.client]) {
          acc[contrat.client] = [];
        }
        acc[contrat.client].push(contrat);
        return acc;
      }, {})
    : {};
    

  // Pagination des données filtrées
  const paginatedContrats = useMemo(() => {
  const start = (currentPage - 1) * itemsPerPage;
  const end = start + itemsPerPage;
  return filteredContrats.slice(start, end);
}, [currentPage, filteredContrats]);

  useEffect(() => {
  setCurrentPage(1);
}, [activeTab, searchQuery]);


  const totalPages = Math.ceil(filteredContrats.length / itemsPerPage);



  

  
  // Export to Excel
  const exportToExcel = () => {
    // Prepare data for Excel export
    const headers = [
      "N° Contrat",
      "Client",
      "Intérimaire",
      "Date Début",
      "Date Fin",
      "Souplesse",
      "Décision Client",
      "Statut",
    ];

    // Create CSV content
    let csvContent = headers.join(",") + "\n";

    // Add data rows
    filteredContrats.forEach((contrat) => {
      const row = [
        contrat.numero,
        `"${contrat.client}"`, // Add quotes to handle commas in text
        `"${contrat.interim}"`,
        contrat.dateDebut,
        contrat.dateFin,
        `"${contrat.souplesse || ""}"`,
        `"${contrat.decisionClient || ""}"`,
        `"${contrat.statut}"`,
      ];
      csvContent += row.join(",") + "\n";
    });

    // Create a Blob and download link
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    // Create download link and trigger click
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `prolongations_${new Date().toISOString().split("T")[0]}.csv`,
    );
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const nombreContratsProlonger = contrats.filter(
    (contrat) => contrat.statut === "à traiter"
  ).length;

  const handlePreviousWeek = () => {
    // Implement previous week logic if needed
    // This is just a placeholder for demonstration
    setCurrentDateRange("31/03/2025-06/04/2025");
  };

  const handleNextWeek = () => {
    // Implement next week logic if needed
    // This is just a placeholder for demonstration
    setCurrentDateRange("14/04/2025-20/04/2025");
  };

  const handleTabChange = (value) => {
    setActiveTab(value);
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case "à traiter":
        return (
          <span className="inline-flex items-center px-3 py-1 rounded-lg text-xs font-semibold bg-amber-100 text-amber-800 border border-amber-200">
            À traiter
          </span>
        );
      case "renouvelé":
        return (
          <span className="inline-flex items-center px-3 py-1 rounded-lg text-xs font-semibold bg-green-100 text-green-800 border border-green-200">
            Renouvelé
          </span>
        );
      case "arrêté":
        return (
          <span className="inline-flex items-center px-3 py-1 rounded-lg text-xs font-semibold bg-red-100 text-red-800 border border-red-200">
            Arrêté
          </span>
        );
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen">
      <div className="container mx-auto py-8 px-4">
        {/* En-tête moderne */}
        <div className="mb-8">
          <div className="flex items-center space-x-4 mb-4">
            <div className="p-3 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl shadow-lg">
              <RefreshCw size={32} className="text-white" />
            </div>
            <div>
              <h1 className="text-4xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">
                Prolongations
              </h1>
              <p className="text-slate-600 mt-1">
                Gérez les prolongations, renouvellements et arrêts des contrats d'intérim en toute simplicité.
              </p>
            </div>
          </div>
        </div>

        {/* Card Summary */}
        {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <Card className="bg-gradient-to-br from-amber-50 to-amber-100 border-amber-200">
            <CardHeader className="pb-2">
              <CardDescription className="text-amber-800 font-medium">À prolonger</CardDescription>
              <CardTitle className="text-3xl text-amber-900">{nombreContratsProlonger}</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-amber-700 text-sm">Contrats nécessitant une prolongation</p>
            </CardContent>
          </Card>
          
          <Card className="bg-gradient-to-br from-emerald-50 to-emerald-100 border-emerald-200">
            <CardHeader className="pb-2">
              <CardDescription className="text-emerald-800 font-medium">Renouvelés</CardDescription>
              <CardTitle className="text-3xl text-emerald-900">{contrats.filter(c => c.statut === "renouvelé").length}</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-emerald-700 text-sm">Contrats prolongés cette période</p>
            </CardContent>
          </Card>
          
          <Card className="bg-gradient-to-br from-rose-50 to-rose-100 border-rose-200">
            <CardHeader className="pb-2">
              <CardDescription className="text-rose-800 font-medium">Arrêtés</CardDescription>
              <CardTitle className="text-3xl text-rose-900">{contrats.filter(c => c.statut === "arrêté").length}</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-rose-700 text-sm">Contrats arrêtés cette période</p>
            </CardContent>
          </Card>
        </div>

        {/* Barre de navigation et recherche */}
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 mb-8">
          <div className="flex flex-col md:flex-row items-center gap-4 mb-4">
            <button
              onClick={handlePreviousWeek}
              className="p-2 hover:bg-slate-100 rounded-lg transition-colors text-slate-600"
            >
              <ChevronLeft size={24} />
            </button>
            <button
              onClick={handleNextWeek}
              className="p-2 hover:bg-slate-100 rounded-lg transition-colors text-slate-600"
            >
              <ChevronRight size={24} />
            </button>
            <div className="flex items-center gap-2">
              <Calendar className="text-blue-600" size={20} />
              <span className="text-lg font-semibold text-slate-800">
                {currentDateRange}
              </span>
            </div>
            <div className="h-6 w-px bg-slate-300"></div>
            <div className="flex-1 relative">
              <Search className="absolute left-3 top-3 text-slate-400" size={20} />
              <input
                type="text"
                placeholder="Rechercher un contrat ou intérimaire..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <Button
              onClick={exportToExcel}
              className="bg-green-600 hover:bg-green-700 text-white rounded-lg flex items-center gap-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              Exporter
            </Button>
          </div>
        </div>

        {/* Tabs */}
        <Tabs
          defaultValue="toutes"
          className="mb-6"
          onValueChange={handleTabChange}
        >
          <div className="mb-6">
            <TabsList className="bg-white border border-slate-200 rounded-xl shadow-sm h-auto p-1">
              <TabsTrigger value="toutes" className="px-4 py-2 text-sm font-medium rounded-lg data-[state=active]:bg-blue-600 data-[state=active]:text-white">
                Toutes
              </TabsTrigger>
              <TabsTrigger value="aTraiter" className="px-4 py-2 text-sm font-medium rounded-lg data-[state=active]:bg-amber-500 data-[state=active]:text-white">
                À traiter
              </TabsTrigger>
              <TabsTrigger value="aRenouveler" className="px-4 py-2 text-sm font-medium rounded-lg data-[state=active]:bg-green-600 data-[state=active]:text-white">
                Renouvelés
              </TabsTrigger>
              <TabsTrigger value="aArreter" className="px-4 py-2 text-sm font-medium rounded-lg data-[state=active]:bg-red-500 data-[state=active]:text-white">
                Arrêtés
              </TabsTrigger>
            </TabsList>
          </div>

          <TabsContent value="toutes">
            <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
              <div className="p-4 bg-slate-50 border-b border-slate-200">
                <h2 className="text-lg font-semibold text-slate-800 flex items-center">
                  <span className="bg-blue-600 text-white px-3 py-1 rounded-lg mr-2">
                    {filteredContrats.length}
                  </span>
                  contrat(s) affichés
                </h2>
              </div>
              {renderContratTable(paginatedContrats)}

              {!groupByClient && totalPages > 1 && (
                <div className="flex justify-between items-center p-4 border-t border-slate-200">
                  <div className="text-center text-sm text-slate-500 mt-2">
                    Page {currentPage} sur {totalPages} • Affichage de {paginatedContrats.length} sur {filteredContrats.length} contrats
                  </div>
                  <PaginationExample
                    totalPages={totalPages}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                  />

                </div>
              )}
            </div>
          </TabsContent>

          <TabsContent value="aTraiter">
            <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
              <div className="p-4 bg-amber-50 border-b border-amber-200">
                <h2 className="text-lg font-semibold text-amber-800 flex items-center">
                  <span className="bg-amber-500 text-white px-3 py-1 rounded-lg mr-2">{aTraiterContrats.length}</span>
                  contrat(s) à traiter
                </h2>
              </div>
              {renderContratTable(aTraiterContrats)}
              {!groupByClient && totalPages > 1 && (
                <div className="p-4 border-t border-slate-200">
                   <PaginationExample
                    totalPages={totalPages}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                    />

                  <div className="text-center text-sm text-slate-500 mt-2">
                    Page {currentPage} sur {totalPages} • Affichage de {paginatedContrats.length} sur {filteredContrats.length} contrats
                  </div>
                </div>
              )}
            </div>
          </TabsContent>

          <TabsContent value="aRenouveler">
            <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
              <div className="p-4 bg-green-50 border-b border-green-200">
                <h2 className="text-lg font-semibold text-green-800 flex items-center">
                  <span className="bg-green-600 text-white px-3 py-1 rounded-lg mr-2">{aRenouvelerContrats.length}</span>
                  contrat(s) renouvelés
                </h2>
              </div>
              {renderContratTable(aRenouvelerContrats)}
              {!groupByClient && totalPages > 1 && (
                <div className="p-4 border-t border-slate-200">
                   <PaginationExample
                    totalPages={totalPages}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                  />

                  <div className="text-center text-sm text-slate-500 mt-2">
                    Page {currentPage} sur {totalPages} • Affichage de {paginatedContrats.length} sur {filteredContrats.length} contrats
                  </div>
                </div>
              )}
            </div>
          </TabsContent>

          <TabsContent value="aArreter">
            <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
              <div className="p-4 bg-red-50 border-b border-red-200">
                <h2 className="text-lg font-semibold text-red-800 flex items-center">
                  <span className="bg-red-500 text-white px-3 py-1 rounded-lg mr-2">{aArreterContrats.length}</span>
                  contrat(s) arrêtés
                </h2>
              </div>
              {renderContratTable(aArreterContrats)}
              {!groupByClient && totalPages > 1 && (
                <div className="p-4 border-t border-slate-200">
                   <PaginationExample
                    totalPages={totalPages}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                  />

                  <div className="text-center text-sm text-slate-500 mt-2">
                    Page {currentPage} sur {totalPages} • Affichage de {paginatedContrats.length} sur {filteredContrats.length} contrats
                  </div>
                </div>
              )}
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );

  function renderContratTable(contrats) {
    if (paginatedContrats.length === 0) {
      return (
        <div className="py-12 text-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="mx-auto h-12 w-12 text-slate-300"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
          <h3 className="mt-4 text-lg font-medium text-slate-900">
            Aucun contrat trouvé
          </h3>
          <p className="mt-2 text-slate-500">
            Aucun résultat ne correspond à vos critères de recherche.
          </p>
        </div>
      );
    }

    return (
      <div className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow className="bg-slate-50 border-b border-slate-200">
              <TableHead className="px-4 py-3 text-left text-sm font-medium text-slate-700">Contrat</TableHead>
              <TableHead className="px-4 py-3 text-left text-sm font-medium text-slate-700">Site</TableHead>
              <TableHead className="px-4 py-3 text-left text-sm font-medium text-slate-700">Intérimaire</TableHead>
              <TableHead className="px-4 py-3 text-left text-sm font-medium text-slate-700">Dates du contrat</TableHead>
              <TableHead className="px-4 py-3 text-left text-sm font-medium text-slate-700">Souplesse</TableHead>
              <TableHead className="px-4 py-3 text-left text-sm font-medium text-slate-700">Votre décision</TableHead>
              <TableHead className="px-4 py-3 text-left text-sm font-medium text-slate-700">Statut</TableHead>
              <TableHead className="px-4 py-3 text-center text-sm font-medium text-slate-700">Action</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {paginatedContrats.map((contrat) => (
              <TableRow
                key={contrat.id}
                className="hover:bg-slate-50 transition-colors border-b border-slate-100"
              >
                <TableCell className="font-medium text-slate-800">{contrat.numero}</TableCell>
                <TableCell className="font-semibold text-slate-800">
                  {contrat.client}
                </TableCell>
                <TableCell className="text-slate-700">{contrat.interim}</TableCell>
                <TableCell>
                  <div className="flex flex-col">
                    <span className="text-sm text-slate-700">
                      {contrat.dateDebut} - {contrat.dateFin}
                    </span>
                  </div>
                </TableCell>
                <TableCell>
                  <span
                    className={`text-sm font-medium ${contrat.souplesse === "Aucune" ? "text-red-600" : "text-green-600"}`}
                  >
                    {contrat.souplesse || "Non définie"}
                  </span>
                </TableCell>
                <TableCell className="text-slate-700">
                  {contrat.decisionClient ? contrat.decisionClient : "-"}
                </TableCell>
                <TableCell>{getStatusBadge(contrat.statut)}</TableCell>
                <TableCell className="text-right">
                  {contrat.statut === "à traiter" ? (
                    <div className="flex justify-center gap-2">
                      <Button
                        className="bg-green-100 hover:bg-green-600 hover:text-white text-green-700 text-xs px-3 py-1 h-8 rounded-lg transition-all"
                        onClick={() => {}}
                      >
                        Prolonger
                      </Button>

                      <Button
                        className="bg-red-100 hover:bg-red-600 hover:text-white text-red-700 text-xs px-3 py-1 h-8 rounded-lg transition-all"
                        onClick={() => {}}
                      >
                        Arrêter
                      </Button>
                    </div>
                  ) : (
                    <span className="text-slate-400 text-sm flex justify-center">—</span>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    );
  }
}
